import {
  AbsoluteContainer,
  Avatar,
  Cushion,
  FlexContainer,
  Grid,
  Rectangle,
  Typography,
} from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../icon';
import { Trans } from '../../lib/i18n';

const MatchAwards = ({ overview }) => {
  if (!overview) return null;
  const { playersOfTheMatch } = overview;
  if (!playersOfTheMatch || playersOfTheMatch.length === 0) return null;

  return (
    <Rectangle
      fill="white"
      style={{ border: '1px solid #d9d9d9', overflow: 'hidden' }}
      responsive={[{ minWidth: 'fullHeader', props: { radius: 'rounded' } }]}
    >
      <Rectangle fill="#fafafa" borderBottom="1px solid #d9d9d9">
        <Cushion all="small">
          <Typography size={16} weight="bold" color="black" align="center" component="h3">
            <Trans i18nKey="teams:match_awards">Match Awards</Trans>
          </Typography>
        </Cushion>
      </Rectangle>
      <FlexContainer flexDirection="column" style={{ gap: '20px' }}>
        {playersOfTheMatch.map((player) => (
          <Cushion all="medium">
            <Grid columns="48px 1fr" columnGap="small" alignItems="center">
              <FlexContainer style={{ position: 'relative', width: '100%' }}>
                <Avatar image={player.avatar} alt={player.name} size={48} />
                <AbsoluteContainer top={0} right={0}>
                  <Icon name="star" size={18} color="gold" />
                </AbsoluteContainer>
              </FlexContainer>
              <FlexContainer flexDirection="column" justifyContent="center">
                <Typography preset="subtitle--small" color="dustygrey" component="h4">
                  <Trans i18nKey="teams:player_of_the_match_label">Star Player</Trans>
                </Typography>
                <Typography preset="body--large" component="div">
                  {player.name}
                </Typography>
              </FlexContainer>
            </Grid>
          </Cushion>
        ))}
      </FlexContainer>
    </Rectangle>
  );
};

MatchAwards.propTypes = {
  overview: PropTypes.shape({
    playersOfTheMatch: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        avatar: PropTypes.string,
      }),
    ),
  }).isRequired,
};

export default MatchAwards;
